export default __webpack_public_path__ + "static/media/fabric2.5e1afa11.png";